import { createIcon } from '../createIcon';

export const AngleDoubleUpIconConfig = {
  name: 'AngleDoubleUpIcon',
  height: 512,
  width: 320,
  svgPath: 'M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z',
  yOffset: 0,
  xOffset: 0,
};

export const AngleDoubleUpIcon = createIcon(AngleDoubleUpIconConfig);

export default AngleDoubleUpIcon;